// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"221":"paragon-theme-core","457":"paragon-theme-variants-light","524":"app"}[chunkId] || chunkId) + "." + {"221":"826b6b7d9f20227c80e5","337":"e764249bd03666a9ce7f","457":"2bf1b84d17f6641240f4","524":"867c8c8136f0a6f30c6f"}[chunkId] + ".css";
};